import { render, staticRenderFns } from "./servidores-pcd.vue?vue&type=template&id=3c596881&scoped=true&"
import script from "./servidores-pcd.vue?vue&type=script&lang=js&"
export * from "./servidores-pcd.vue?vue&type=script&lang=js&"
import style0 from "./servidores-pcd.vue?vue&type=style&index=0&id=3c596881&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c596881",
  null
  
)

export default component.exports